import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField
} from "@material-ui/core";
import { inject, observer } from "mobx-react";
import React from "react";
import * as Icon from "react-feather";
import * as C from "vonnegut.components";
import QuestionListItemActions from "./question-item-actions";

const QuestionListItem = ({ question, store, order }) => {
  const { $question, $locale, $answer, $router, $user, $config, $group } = store;

  const mentor = $router.getURLParameterByName("mentor");
  const orderClass = `${mentor ? "block" : "show-for-print"}`;
  const name = $locale.t(question._key);
  const description = $locale.t(question._key + "_description");
  const type = $config.field_types.find(type => type.value === question.type);
  const typeOptions = (type && type.options) || question.translatedTypeOptions;

  return (
    <div
      className={`question-content ${question.type === "fieldset" ? "legend" : question.type}`}
      id={question._key}
    >
      {question.type === "fieldset" && (
        <h2 className="flex mb-4">
          <span className={orderClass}>{order}.&nbsp;</span>
          {name}
        </h2>
      )}

      {question.type === "list" && (
        <React.Fragment>
          <div className="field">
            <label id={question._key + "label"}>{name}</label>

            {question.multipleAnswers ? (
              <FormGroup>
                {question.translatedTypeOptions.map(option => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        value={option.value}
                        checked={question.answerTemp && question.answerTemp.includes(option.value)}
                        onChange={e =>
                          $answer.setTempAnswerValue(
                            {
                              target: { ...e.target, ...{ value: e.target.value, multiple: true } }
                            },
                            question
                          )
                        }
                        name={option.label}
                      />
                    }
                    label={option.label}
                  />
                ))}
              </FormGroup>
            ) : (
              <Select
                labelId={question._key + "label"}
                value={question.answerTemp}
                onChange={e => $answer.setTempAnswerValue(e, question)}
              >
                <MenuItem disabled value="">
                  <em>{name}</em>
                </MenuItem>
                {question.translatedTypeOptions.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            )}
          </div>

          <C.RadioGroup label={name} required={question.required} className="show-for-print">
            {question.translatedTypeOptions.map((option, i) => (
              <C.Radio
                value={option.value}
                label={`${order}&nbsp;${option.label}`}
                key={"option" + i}
                className="mr-4"
                type="radio"
                onChange={e => false}
                name={question._key}
              />
            ))}
          </C.RadioGroup>
        </React.Fragment>
      )}

      {question.type === "legend" && <h5>{name}</h5>}

      {question.type === "boolean" && (
        <div className="boolean">
          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">
              <Box display="flex">
                <span className={orderClass}>{order}.&nbsp;</span>
                {name}
              </Box>
            </FormLabel>
            <RadioGroup
              aria-label={name}
              required={question.required}
              disabled={$router.mode !== "view"}
              name={question._key}
              value={String(question.answerTemp)}
              onChange={e => $answer.setTempAnswerValue(e, question)}
            >
              <Box display="flex">
                {["ja", "nee"].map(option => (
                  <Box textAlign="center" key={option}>
                    <FormControlLabel
                      value={option}
                      control={
                        <Radio
                          color="primary"
                          onClick={() =>
                            option === String(question.answerTemp) &&
                            $answer.setTempAnswerValue({ target: { value: "" } }, question)
                          }
                        />
                      }
                      label={option === "ja" ? $locale.t("boolean_yes") : $locale.t("boolean_no")}
                      labelPlacement="end"
                    />
                  </Box>
                ))}
              </Box>
            </RadioGroup>
          </FormControl>
        </div>
      )}

      {question.type === "text" && (
        <TextField
          fullWidth
          multiline
          rows={5}
          label={
            <div className="flex">
              <span className={orderClass}>{order}&nbsp;</span>
              <span>{name}</span>
            </div>
          }
          disabled={$router.mode !== "view"}
          value={question.answerTemp}
          name={question._key}
          onChange={e => $answer.setTempAnswerValue(e, question)}
          required={question.required}
        />
      )}

      {(question.type === "email" || question.type === "number" || question.type === "date") && (
        <div className="flex">
          <span className={orderClass}>{order}. </span>
          <TextField
            fullWidth
            label={name}
            type={question.type}
            disabled={$router.mode !== "view"}
            value={question.answerTemp}
            name={question._key}
            onChange={e => $answer.setTempAnswerValue(e, question)}
            required={question.required}
            InputLabelProps={{ ...(question.type === "date" && { shrink: true }) }}
          />
        </div>
      )}

      {question.type.indexOf("scale") > -1 && (
        <div className="scale">
          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">
              <Box display="flex">
                <span className={orderClass}>{order}.&nbsp;</span>
                {name}
              </Box>
            </FormLabel>
            <RadioGroup
              aria-label="name"
              required={question.required}
              disabled={$router.mode !== "view"}
              name={question._key}
              value={String(question.answerTemp)}
              onChange={e => $answer.setTempAnswerValue(e, question)}
            >
              <Box display="flex" justifyContent="space-between">
                {typeOptions.map((option, i) => (
                  <Box width={1 / typeOptions.length} textAlign="center" key={option.value}>
                    <FormControlLabel
                      value={String(option.value)}
                      control={
                        <Radio
                          color="primary"
                          onClick={() =>
                            String(option.value) === String(question.answerTemp) &&
                            $answer.setTempAnswerValue({ target: { value: "" } }, question)
                          }
                        />
                      }
                      label={$locale.t(question.type + "_" + option.key) || option.label}
                      labelPlacement="bottom"
                    />
                  </Box>
                ))}
              </Box>
            </RadioGroup>
          </FormControl>
        </div>
      )}

      {question.type === "hidden" && (
        <TextField
          label={name + " (verborgen)"}
          disabled={true}
          value={question.answerTemp || ""}
          name={question._key}
        />
      )}

      {description && <div className="description mt-2">{description}</div>}

      <QuestionListItemActions question={question} />

      {$router.mode !== "view" &&
        question.isEditable &&
        ($user.sessionUser.isVerifiedCreator ||
          ($user.sessionUser.isVerifiedMentor &&
            $group.selected &&
            $group.selected._key === question.createdForGroup)) &&
        question.type === "fieldset" &&
        !question.children.length && (
          <Button
            startIcon={<Icon.Plus className="color-white" />}
            className="mt-4 bg-primary"
            onClick={() => {
              $locale.clearSelectedList();
              $question.setSelected({
                _key: "new",
                order: 100,
                parentKey: question._key || null
              });
            }}
          >
            {"Nieuwe vraag"}
          </Button>
        )}
    </div>
  );
};

export default inject("store")(observer(QuestionListItem));
